import { render, staticRenderFns } from "./px-navigation-tab-item.vue?vue&type=template&id=19f4d1f2&scoped=true&"
import script from "./px-navigation-tab-item.vue?vue&type=script&lang=ts&"
export * from "./px-navigation-tab-item.vue?vue&type=script&lang=ts&"
import style0 from "./px-navigation-tab-item.vue?vue&type=style&index=0&id=19f4d1f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f4d1f2",
  null
  
)

export default component.exports